#import '../queries/SentenceGroupDetails.graphql'
#import '../queries/SentenceDetails.graphql'
mutation CreateSentenceGroup($description: String!, $text: [String!]!, $id: ID, $username: String, $category: ID) {
  createSentenceGroup(description: $description, text: $text, id: $id, username: $username, category: $category) {
    ok
    errors
    sentenceGroup {
      ...sentenceGroupDetails
    }
  }
}
